import { render, staticRenderFns } from "./PBaseInfo.vue?vue&type=template&id=6d5fbbc5&scoped=true&"
import script from "./PBaseInfo.vue?vue&type=script&lang=ts&"
export * from "./PBaseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PBaseInfo.vue?vue&type=style&index=0&id=6d5fbbc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fbbc5",
  null
  
)

export default component.exports